import * as sagas from '../helpers/sagas';
import { types } from '../actions/events';
import { api } from '../resources/events';

const takeLatest = [
  {
    type: types.EVENTS_LATEST,
    call: api.latest,
  },
  {
    type: types.EVENTS_SHOW,
    call: api.show,
  },
  {
    type: types.EVENTS_TICKETS,
    call: api.tickets,
  },
  {
    type: types.EVENTS_TICKETS_CURATED,
    call: api.ticketsCurated,
  },
];

const events = takeLatest.map(sagas.makeTakeLatest);

export default events;



// WEBPACK FOOTER //
// ./src/sagas/events.js